/*
 * Authors: mariushirjanu
 * Created: 24/06/2022
 */
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { IDialogButton } from '../../../shared/message/ga-message.service';
import { IOrderFeesHeader, IOrderFeesRejectProforma, OrderFeesDataService } from './order-fees-data.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../shared/formly/ga-formly.service';
import { FormattingService } from '../../../shared/services/formatting.service';
import { GaValidateService } from '../../../shared/formly/ga-validate.service';

@Component({
  selector: 'reject-proforma-dialog',
  template: `
    <default-dialog [title]="title" [buttons]="buttons">
      <formly [form]="form" [fields]="fields" [model]="model"></formly>
    </default-dialog>
  `
})
export class RejectProformaDialogComponent implements OnInit {
  @Input() public title:string;
  @Input() public isInDialog:boolean;
  @Input() public bpId:number;
  @Input() public invoiceId:number;
  @Output() public onSaved:EventEmitter<IOrderFeesHeader> = new EventEmitter<IOrderFeesHeader>();

  public form:UntypedFormGroup = new UntypedFormGroup({});
  public fields:IExtraFieldConfigurationObject[];
  public model:IOrderFeesRejectProforma;
  public buttons:IDialogButton[];


  constructor(
    private formattingService:FormattingService,
    private formlyService:GaFormlyService,
    private orderFeesDataService:OrderFeesDataService,
    private validateService:GaValidateService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.start();
  }

  private start():void {
    this.buttons = [ {
      label: this.title,
      className: 'btn btn-success',
      onClick: () => this.doReject()
    }, {
      label: 'GA.BUTTONS.CANCEL',
      className: 'btn btn-danger'
    } ];

    this.fields = this.createFields();
    this.model = {};
  }

  private createFields():IExtraFieldConfigurationObject[] {
    const fields:IExtraFieldConfigurationObject[] = [];
    const labelClass:string = 'col-md-12';
    const valueClass:string = 'col-md-12';

    fields.push(
      this.formlyService.aTextarea('reason')
        .isRequired()
        .withEditable('rejectionReason')
        .withLabelClass(labelClass)
        .withValueClass(valueClass)
        .build()
    );

    return fields;
  }

  private doReject = ():void => {
    this.validateService.validateFields(this.fields, this.model, true)
      .then(() => {
        this.orderFeesDataService.rejectProforma(this.invoiceId, this.model)
          .then((invoiceHeader:IOrderFeesHeader) => {
            this.onSaved.emit(invoiceHeader);
          });
      });
  };
}